import { lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Biniyog from '../../../../../libs/shared/external-navbar/src/lib/Icons/Logo_Biniyog.webp';
import '../../../../../libs/ui/src/lib/ui.css';
import './app.scss';
import BankCalculatorLazy from './routes/external/bank-calculator/lazy';
import BankMainPageLazy from './routes/external/bank-main/lazy';
import CompanyPageLazy from './routes/external/company-page/lazy';
import ExternalFormPageLazy from './routes/external/external-form/lazy';
import KSCLWebsite1Lazy from './routes/external/kscl-website-1/lazy';
import KSCLWebsite2Lazy from './routes/external/kscl-website-2/lazy';
import KSCLWebsite3Lazy from './routes/external/kscl-website-3/lazy';
import KSCLWebsite4Lazy from './routes/external/kscl-website-4/lazy';
import LatestSharePriceLazy from './routes/external/latest-share-price/lazy';
import MakePaymentLazy from './routes/external/make-payment/lazy';
import NotFoundLazy from './routes/external/not-found/lazy';
import RebateCalculatorLazy from './routes/external/rebate-calculator/lazy';
import ShareMarketChartLazy from './routes/external/sharemarket-chart/sharemarket-chart.lazy';
import ScLBLazy from './routes/external/stock-contest-leader-board/lazy';
import StockContestLazy from './routes/external/stock-contest/lazy';
import SubscriptionLazy from './routes/external/subscriptions/lazy';
import InternalLazy from './routes/internal/internal.lazy';

const ShareMarketLazy = lazy(() => import('./routes/external/sharemarket/sharemarket'));
const DseNewsLazy = lazy(() => import('./routes/external/dse-news/dse-news'));

const isFound = (pathname) => {
  if (pathname === '/') return true;

  const paths = ['account-settings', 'tax', 'equity'];
  const authPaths = ['signup', 'reset-password'];
  const ps = pathname?.split('/');

  if (ps?.length > 1 && paths.includes(ps[1])) return true;
  if (ps?.length > 1 && authPaths.includes(ps[1])) return true;

  return false;
};

const Loading = () => (
  <div style={{ fontSize: '12px' }} className="loading-logo">
    Loading...
  </div>
);

const externalRoutes = [
  { path: '/sharemarket/main', element: ShareMarketLazy, header: true, footer: true, fallback: null },
  { path: '/dse-news', element: DseNewsLazy, header: true, footer: true, fallback: null },
];

export function App() {
  const { pathname } = useLocation();

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
      <link rel="preload" as="image" href={Biniyog} />

      <link rel="preconnect" href="https://dse.biniyog.com.bd" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://firebase.googleapis.com" crossOrigin="anonymous" />
      <Routes>
        {externalRoutes?.map((r: any, idx: number) => (
          <Route
            key={idx}
            path={r?.path}
            element={
              <Suspense fallback={r?.fallback ? <r.fallback /> : <Loading />}>
                {r?.element ? <r.element /> : ''}
              </Suspense>
            }
          />
        ))}
        <Route path="/sharemarket/chart" element={<ShareMarketChartLazy />} />
        <Route path="/subscriptions" element={<SubscriptionLazy />} />
        <Route path="/company/:tradingCode" element={<CompanyPageLazy />} />
        <Route path="/external-form/:id" element={<ExternalFormPageLazy />} />
        <Route path="/bank/main" element={<BankMainPageLazy />} />
        <Route path="/bank/calculator/:schemeType/:bankname" element={<BankCalculatorLazy />} />
        <Route path="/bank/calculator" element={<BankCalculatorLazy />} />
        <Route path="/latest-share-price" element={<LatestSharePriceLazy />} />
        {/* <Route path="/dse-news" element={<DseNewsLazy />} /> */}
        <Route path="/stock/contest/:contestId/leader-board" element={<ScLBLazy />} />
        <Route path="/stock/contest" element={<StockContestLazy />} />
        <Route path="/make-payment/*" element={<MakePaymentLazy />} />
        <Route path="/tax/rebate-calculator" element={<RebateCalculatorLazy />} />
        <Route path="/kscl-website-1" element={<KSCLWebsite1Lazy />} />
        <Route path="/kscl-website-2" element={<KSCLWebsite2Lazy />} />
        <Route path="/kscl-website-3" element={<KSCLWebsite3Lazy />} />
        <Route path="/kscl-website-4" element={<KSCLWebsite4Lazy />} />
        <Route path="/404" element={<NotFoundLazy />} />

        <Route path="*" element={isFound(pathname) ? <InternalLazy /> : <NotFoundLazy />} />
      </Routes>
    </div>
  );
}

export default App;
